export const SIDE_PANEL_NAV_EVENT = "ft:sidepanel-nav" as const

export const notifySidePanelNav = (): void => {
  if (typeof window === "undefined") return
  window.dispatchEvent(new CustomEvent(SIDE_PANEL_NAV_EVENT))
}
